import {format, parseISO} from "date-fns";

const isoDateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d*)?$/;
const iso8601DateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;

export function isIsoDateString(value: any): boolean {
    return value && typeof value === "string" && isoDateFormat.test(value);
}

export function isIso8601DateFormat(value: any): boolean {
    return value && typeof value === "string" && iso8601DateFormat.test(value);
}

export const convertIso8601ToCustomFormat = (isoDate: string): string => {
    const date = new Date(isoDate);

    const yyyy = date.getUTCFullYear().toString();
    const MM = String(date.getUTCMonth() + 1).padStart(2, '0');
    const dd = String(date.getUTCDate()).padStart(2, '0');
    const HH = String(date.getUTCHours()).padStart(2, '0');
    const mm = String(date.getUTCMinutes()).padStart(2, '0');
    const ss = String(date.getUTCSeconds()).padStart(2, '0');

    return `${yyyy}-${MM}-${dd}T${HH}:${mm}:${ss}`;
}


export const handleRequestDates = (body: any) => {
    if (body === null || body === undefined) {
        return body;
    }

    if (typeof body === "object") {
        for (const key of Object.keys(body)) {
            const value = body[key];
            if (value instanceof Date) {
                body[key] = format(value, "yyyy-MM-dd'T'HH:mm:ss");
            } else if (Array.isArray(value)) {
                for (const item of value) {
                    if (typeof item === "object") handleRequestDates(item);
                }
            } else if (typeof value === "object") {
                handleRequestDates(value);
            }
        }
    }
}

export const handleResponseDates = (body: any) => {
    if (body === null || body === undefined || typeof body !== "object") {
        return body;
    }

    for (const key of Object.keys(body)) {
        const value = body[key];
        if (isIsoDateString(value)) {
            body[key] = parseISO(value);
        } else if (Array.isArray(value)) {
            for (const item of value) {
                if (typeof item === "object") handleResponseDates(item);
            }
        } else {
            if (typeof value === "object") handleResponseDates(value);
        }
    }
};

